// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-panel-cis{
    width: 100%;
    height: 100%;
    position: relative;
    background-color: transparent;
    display: flex;
    justify-content: center;
    align-items: center;
}
.content-cis{
    position: relative;
    justify-content: center;
    display: block;
    height: 98%;
    width: 94%;
border-radius:10px ;
box-shadow: 0 0 5px 5px rgba(24, 94, 224, 0.15), 0 6px 12px 0 rgba(24, 94, 224, 0.15);
border: 2px solid #003757;
  border-radius: 10px;
}
.cont-cis-search{
position: relative;
  height: 10%;
  width: 100%;
  /* background: rgba(195,195,195); */
  background: #003757;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px 5px 0px 0px;
}
.cont-search{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 25%;
}
.cont-search-space{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 55%;
}
.cont-search-buttons{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 20%;
}
.cont-cis-table{
    position: relative;
  height: 90%;
  width: 100%;
  /* background: rgba(195,195,195); */
  /* background: #003757; */
  display: flex;
  justify-content: center;
  align-items: center;
}
.content-card-cis{
    position: relative;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}


  /****************************** tabla usuarios ******************************************/
  .cont-table-cis{
    width: 98%;
    height: 99%;
    /* border: 1px solid #56575746; */
    border-radius: 5px;
    display: block;
    position: relative;
  }
  .head-table-cis{
    width: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 7%;
    background-color: rgb(138, 138, 138);
    /* background:#4392c0; */
    /* border-bottom: 1px solid #003757; */
     border-radius: 5px 5px 0px 0px;
     font-size: 11px;
  }
  .field-head-table-cis{
    height: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    color: aliceblue;
    text-align: center;
  }
  .field-head-table-cis.field-nombre,.field-head-table-cis.field-small{
    border-right: 1px solid rgba(240, 248, 255, 0.473);
  }

  .field-small{
    width: 5%;
    border-right: 1px solid rgba(240, 248, 255, 0.473);
  }
  .field-larger{
    width: 12%;
    border-right: 1px solid rgba(240, 248, 255, 0.473);
  }

  .field-medium{
    width: 7%;
    border-right: 1px solid rgba(240, 248, 255, 0.473);
  }
  .body-table-cis{
    width: 100%;
    position: relative;
    display:block;
    justify-content: center;
    align-items: center;
    height: 90%;
    overflow: 'auto';
     
    
  }
  .row-table-cis{
    position: relative;
    display: flex;
    width: 100%;
    height: 40px;
    color:#003757;
  }
  .row-table-cis:nth-child(odd){
    background-color: #f8f9fa;
  }
  .row-table-cis:nth-child(even){
    background-color: #eeeeee;
  }
  .field-body-table-cis {
    position: relative;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 11px;
    text-align: center;
    word-wrap: anywhere;
  }
  .row-table-cis:hover{
    /* background-color: #00375771; */
    background-color: #004e7ba4;
    cursor: pointer;
    color: aliceblue !important;
  }
  /* .field-body-table-cis.field-nombre,.field-body-table-cis.field-acciones{
    border-right: 1px solid #0037573a;
  } */
/****************************** tabla usuarios Config ******************************************/
.cont-table-cis-config{
  width: 98%;
  height: 99%;
  /* border: 1px solid #56575746; */
  border-radius: 5px;
  display: block;
  position: relative;
}
.head-table-cis-config{
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 10%;
  background-color: rgb(138, 138, 138);
  /* background:#4392c0; */
  /* border-bottom: 1px solid #003757; */
   border-radius: 5px 5px 0px 0px;
   font-size: 11px;
  
}
.field-head-table-cis-config{
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  color: aliceblue;
  text-align: center;
}
.field-head-table-cis-config.field-nombre,.field-head-table-cis-config.field-small{
  border-right: 1px solid rgba(240, 248, 255, 0.473);
}

.field-small{
  width: 4%;
  border-right: 1px solid rgba(240, 248, 255, 0.473);
}
.field-larger{
  width: 12%;
  border-right: 1px solid rgba(240, 248, 255, 0.473);
}

.field-medium{
  width: 7%;
  border-right: 1px solid rgba(240, 248, 255, 0.473);
}
.body-table-cis-config{
  width: 100%;
  position: relative;
  display:block;
  justify-content: center;
  align-items: center;
  height: 90%;
  overflow: 'auto';
   
  
}
.row-table-cis-config{
  position: relative;
  display: flex;
  width: 100%;
  height: 40px;
  color:#003757;
}
.row-table-cis-config:nth-child(odd){
  background-color: #f8f9fa;
}
.row-table-cis-config:nth-child(even){
  background-color: #eeeeee;
}
.field-body-table-cis-config {
  position: relative;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 11px;
  text-align: center;
}
.row-table-cis-config:hover{
  background-color: #003757d3;
  cursor: pointer;
  color: aliceblue !important;
}
/* .field-body-table-cis-config.field-nombre,.field-body-table-cis-config.field-acciones{
  border-right: 1px solid #0037573a;
} */
  .cont-img-field-acciones{
    position: relative;
    width: 50%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .img-field-acciones{
    position: relative;
    height: 70%;
  }

  .img-field-acciones:hover{
    transform: scale(1.1);
    transition: 0.3s;
  }
  .cont-load-user-list{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
  }
  .cont-row-user-list{
    width: 100%;
    height: 100%;
    overflow: auto;
  }
  .field-body-table-cis {
    position: relative;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    /* font-size: small; */
    
  }
  .row-table-cis{
    position: relative;
    display: flex;
    width: 100%;
    height: 40px;
    color:#003757;
  }
  .row-table-cis:nth-child(odd){
    background-color: #f8f9fa;
  }
  .row-table-cis:nth-child(even){
    background-color: #eeeeee;
  }
  .field-body-table-cis {
    position: relative;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    /* font-size: small; */
    
  }
  .row-table-cis:hover{
    background-color: #003757d3;
    cursor: pointer;
    color: aliceblue !important;
  }
 
  .form-msg-ok{
    color: #149209;
    position: absolute;
    left:0;
    /* top:10% */
    bottom: 0%;
    background-color: rgba(211, 255, 217, 0.64);
    width: 99%;
    text-align: center;
    border: 2px solid #149209;
    border-radius: 5px;
  }
  .no-results{
    position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: gray;
  }
  .pdf-download{
    position: absolute;
    width: 10%;
    left: 90%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .img-down-pdf{
    height: 70%;
  }
  .img-down-pdf:hover{
    height: 80%;
    cursor: pointer;
  }

 .txtCisCancelada{
  font-weight: bold;
  color:red
 }
 .txtCisRechazada{
  font-weight: bold;
  color:red
 }  
 .txtCisCerrada{
  font-weight: bold;
  color:green
 }
 .txtCisIniciada{
  font-weight: bold;
  color:#d9bb18
 }
 .txtCisIniciado{
  font-weight: bold;
  color:#d9bb18
 }
 .txtCisNo{
  font-weight: bold;
  color:#000000
 }
 .txtCisPendiente{
  color:red
 }
 .Tooltip-coment{
  position: absolute;
  width: 130%;
  /* min-width: 80%; */
  height: 80%;
  background-color: rgba(240, 248, 255, 0.793);
  border: 1px solid grey;
  border-radius: 10px;
  /* top:-10px; */
  color:rgb(68, 68, 68);
  left: 110%;
  z-index: 5;
  display: none;
  justify-content: center;
  align-items: center;
 }

 .field-status:hover .Tooltip-coment{
  display: flex;
 }
 
 `, "",{"version":3,"sources":["webpack://./src/components/provicionamiento-componentes/styles/PanelCis.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,6BAA6B;IAC7B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,cAAc;IACd,WAAW;IACX,UAAU;AACd,mBAAmB;AACnB,qFAAqF;AACrF,yBAAyB;EACvB,mBAAmB;AACrB;AACA;AACA,kBAAkB;EAChB,WAAW;EACX,WAAW;EACX,mCAAmC;EACnC,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B;AAChC;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,UAAU;AACd;AACA;IACI,kBAAkB;EACpB,WAAW;EACX,WAAW;EACX,mCAAmC;EACnC,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;;EAGE,yFAAyF;EACzF;IACE,UAAU;IACV,WAAW;IACX,iCAAiC;IACjC,kBAAkB;IAClB,cAAc;IACd,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,oCAAoC;IACpC,wBAAwB;IACxB,sCAAsC;KACrC,8BAA8B;KAC9B,eAAe;EAClB;EACA;IACE,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,kDAAkD;EACpD;;EAEA;IACE,SAAS;IACT,kDAAkD;EACpD;EACA;IACE,UAAU;IACV,kDAAkD;EACpD;;EAEA;IACE,SAAS;IACT,kDAAkD;EACpD;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;;;EAGlB;EACA;IACE,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,YAAY;IACZ,aAAa;EACf;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,iCAAiC;IACjC,2BAA2B;IAC3B,eAAe;IACf,2BAA2B;EAC7B;EACA;;KAEG;AACL,gGAAgG;AAChG;EACE,UAAU;EACV,WAAW;EACX,iCAAiC;EACjC,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,oCAAoC;EACpC,wBAAwB;EACxB,sCAAsC;GACrC,8BAA8B;GAC9B,eAAe;;AAElB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kDAAkD;AACpD;;AAEA;EACE,SAAS;EACT,kDAAkD;AACpD;AACA;EACE,UAAU;EACV,kDAAkD;AACpD;;AAEA;EACE,SAAS;EACT,kDAAkD;AACpD;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;;;AAGlB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,aAAa;AACf;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,2BAA2B;EAC3B,eAAe;EACf,2BAA2B;AAC7B;AACA;;GAEG;EACD;IACE,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;;EAExB;EACA;IACE,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,YAAY;IACZ,aAAa;EACf;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;;EAExB;EACA;IACE,2BAA2B;IAC3B,eAAe;IACf,2BAA2B;EAC7B;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,YAAY;IACZ,UAAU;IACV,2CAA2C;IAC3C,UAAU;IACV,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,eAAe;EACjB;;CAED;EACC,iBAAiB;EACjB;CACD;CACA;EACC,iBAAiB;EACjB;CACD;CACA;EACC,iBAAiB;EACjB;CACD;CACA;EACC,iBAAiB;EACjB;CACD;CACA;EACC,iBAAiB;EACjB;CACD;CACA;EACC,iBAAiB;EACjB;CACD;CACA;EACC;CACD;CACA;EACC,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,WAAW;EACX,4CAA4C;EAC5C,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,UAAU;EACV,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;CACpB;;CAEA;EACC,aAAa;CACd","sourcesContent":[".main-panel-cis{\n    width: 100%;\n    height: 100%;\n    position: relative;\n    background-color: transparent;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.content-cis{\n    position: relative;\n    justify-content: center;\n    display: block;\n    height: 98%;\n    width: 94%;\nborder-radius:10px ;\nbox-shadow: 0 0 5px 5px rgba(24, 94, 224, 0.15), 0 6px 12px 0 rgba(24, 94, 224, 0.15);\nborder: 2px solid #003757;\n  border-radius: 10px;\n}\n.cont-cis-search{\nposition: relative;\n  height: 10%;\n  width: 100%;\n  /* background: rgba(195,195,195); */\n  background: #003757;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 5px 5px 0px 0px;\n}\n.cont-search{\n    position: relative;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n    width: 25%;\n}\n.cont-search-space{\n    position: relative;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n    width: 55%;\n}\n.cont-search-buttons{\n    position: relative;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n    width: 20%;\n}\n.cont-cis-table{\n    position: relative;\n  height: 90%;\n  width: 100%;\n  /* background: rgba(195,195,195); */\n  /* background: #003757; */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.content-card-cis{\n    position: relative;\n    height: 100%;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n\n  /****************************** tabla usuarios ******************************************/\n  .cont-table-cis{\n    width: 98%;\n    height: 99%;\n    /* border: 1px solid #56575746; */\n    border-radius: 5px;\n    display: block;\n    position: relative;\n  }\n  .head-table-cis{\n    width: 100%;\n    position: relative;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 7%;\n    background-color: rgb(138, 138, 138);\n    /* background:#4392c0; */\n    /* border-bottom: 1px solid #003757; */\n     border-radius: 5px 5px 0px 0px;\n     font-size: 11px;\n  }\n  .field-head-table-cis{\n    height: 100%;\n    position: relative;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: aliceblue;\n    text-align: center;\n  }\n  .field-head-table-cis.field-nombre,.field-head-table-cis.field-small{\n    border-right: 1px solid rgba(240, 248, 255, 0.473);\n  }\n\n  .field-small{\n    width: 5%;\n    border-right: 1px solid rgba(240, 248, 255, 0.473);\n  }\n  .field-larger{\n    width: 12%;\n    border-right: 1px solid rgba(240, 248, 255, 0.473);\n  }\n\n  .field-medium{\n    width: 7%;\n    border-right: 1px solid rgba(240, 248, 255, 0.473);\n  }\n  .body-table-cis{\n    width: 100%;\n    position: relative;\n    display:block;\n    justify-content: center;\n    align-items: center;\n    height: 90%;\n    overflow: 'auto';\n     \n    \n  }\n  .row-table-cis{\n    position: relative;\n    display: flex;\n    width: 100%;\n    height: 40px;\n    color:#003757;\n  }\n  .row-table-cis:nth-child(odd){\n    background-color: #f8f9fa;\n  }\n  .row-table-cis:nth-child(even){\n    background-color: #eeeeee;\n  }\n  .field-body-table-cis {\n    position: relative;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 11px;\n    text-align: center;\n    word-wrap: anywhere;\n  }\n  .row-table-cis:hover{\n    /* background-color: #00375771; */\n    background-color: #004e7ba4;\n    cursor: pointer;\n    color: aliceblue !important;\n  }\n  /* .field-body-table-cis.field-nombre,.field-body-table-cis.field-acciones{\n    border-right: 1px solid #0037573a;\n  } */\n/****************************** tabla usuarios Config ******************************************/\n.cont-table-cis-config{\n  width: 98%;\n  height: 99%;\n  /* border: 1px solid #56575746; */\n  border-radius: 5px;\n  display: block;\n  position: relative;\n}\n.head-table-cis-config{\n  width: 100%;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 10%;\n  background-color: rgb(138, 138, 138);\n  /* background:#4392c0; */\n  /* border-bottom: 1px solid #003757; */\n   border-radius: 5px 5px 0px 0px;\n   font-size: 11px;\n  \n}\n.field-head-table-cis-config{\n  height: 100%;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: aliceblue;\n  text-align: center;\n}\n.field-head-table-cis-config.field-nombre,.field-head-table-cis-config.field-small{\n  border-right: 1px solid rgba(240, 248, 255, 0.473);\n}\n\n.field-small{\n  width: 4%;\n  border-right: 1px solid rgba(240, 248, 255, 0.473);\n}\n.field-larger{\n  width: 12%;\n  border-right: 1px solid rgba(240, 248, 255, 0.473);\n}\n\n.field-medium{\n  width: 7%;\n  border-right: 1px solid rgba(240, 248, 255, 0.473);\n}\n.body-table-cis-config{\n  width: 100%;\n  position: relative;\n  display:block;\n  justify-content: center;\n  align-items: center;\n  height: 90%;\n  overflow: 'auto';\n   \n  \n}\n.row-table-cis-config{\n  position: relative;\n  display: flex;\n  width: 100%;\n  height: 40px;\n  color:#003757;\n}\n.row-table-cis-config:nth-child(odd){\n  background-color: #f8f9fa;\n}\n.row-table-cis-config:nth-child(even){\n  background-color: #eeeeee;\n}\n.field-body-table-cis-config {\n  position: relative;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 11px;\n  text-align: center;\n}\n.row-table-cis-config:hover{\n  background-color: #003757d3;\n  cursor: pointer;\n  color: aliceblue !important;\n}\n/* .field-body-table-cis-config.field-nombre,.field-body-table-cis-config.field-acciones{\n  border-right: 1px solid #0037573a;\n} */\n  .cont-img-field-acciones{\n    position: relative;\n    width: 50%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  .img-field-acciones{\n    position: relative;\n    height: 70%;\n  }\n\n  .img-field-acciones:hover{\n    transform: scale(1.1);\n    transition: 0.3s;\n  }\n  .cont-load-user-list{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n  }\n  .cont-row-user-list{\n    width: 100%;\n    height: 100%;\n    overflow: auto;\n  }\n  .field-body-table-cis {\n    position: relative;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    /* font-size: small; */\n    \n  }\n  .row-table-cis{\n    position: relative;\n    display: flex;\n    width: 100%;\n    height: 40px;\n    color:#003757;\n  }\n  .row-table-cis:nth-child(odd){\n    background-color: #f8f9fa;\n  }\n  .row-table-cis:nth-child(even){\n    background-color: #eeeeee;\n  }\n  .field-body-table-cis {\n    position: relative;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    /* font-size: small; */\n    \n  }\n  .row-table-cis:hover{\n    background-color: #003757d3;\n    cursor: pointer;\n    color: aliceblue !important;\n  }\n \n  .form-msg-ok{\n    color: #149209;\n    position: absolute;\n    left:0;\n    /* top:10% */\n    bottom: 0%;\n    background-color: rgba(211, 255, 217, 0.64);\n    width: 99%;\n    text-align: center;\n    border: 2px solid #149209;\n    border-radius: 5px;\n  }\n  .no-results{\n    position: relative;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: gray;\n  }\n  .pdf-download{\n    position: absolute;\n    width: 10%;\n    left: 90%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  .img-down-pdf{\n    height: 70%;\n  }\n  .img-down-pdf:hover{\n    height: 80%;\n    cursor: pointer;\n  }\n\n .txtCisCancelada{\n  font-weight: bold;\n  color:red\n }\n .txtCisRechazada{\n  font-weight: bold;\n  color:red\n }  \n .txtCisCerrada{\n  font-weight: bold;\n  color:green\n }\n .txtCisIniciada{\n  font-weight: bold;\n  color:#d9bb18\n }\n .txtCisIniciado{\n  font-weight: bold;\n  color:#d9bb18\n }\n .txtCisNo{\n  font-weight: bold;\n  color:#000000\n }\n .txtCisPendiente{\n  color:red\n }\n .Tooltip-coment{\n  position: absolute;\n  width: 130%;\n  /* min-width: 80%; */\n  height: 80%;\n  background-color: rgba(240, 248, 255, 0.793);\n  border: 1px solid grey;\n  border-radius: 10px;\n  /* top:-10px; */\n  color:rgb(68, 68, 68);\n  left: 110%;\n  z-index: 5;\n  display: none;\n  justify-content: center;\n  align-items: center;\n }\n\n .field-status:hover .Tooltip-coment{\n  display: flex;\n }\n \n "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
